import { render, staticRenderFns } from "./batchHandle.vue?vue&type=template&id=0f604816&scoped=true"
import script from "./batchHandle.vue?vue&type=script&lang=js"
export * from "./batchHandle.vue?vue&type=script&lang=js"
import style0 from "./batchHandle.vue?vue&type=style&index=0&id=0f604816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f604816",
  null
  
)

export default component.exports